import { Typography } from '@mui/material';
import ExoForm from '../../../components/exo/ExoForm';
import * as Yup from 'yup';
import { API_DELETE, API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import Feedback from '../../../components/special/Feedback';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StartIcon from '@mui/icons-material/Start';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';

const NewCompanyHoliday = ({ existingData, onSubmit, onCancel, onDelete }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const fields = [
    {
      Icon: StartIcon,
      label: t('Start'),
      type: 'date',
      key: 'startDate',
    },
    {
      Icon: KeyboardTabIcon,
      label: t('End'),
      type: 'date',
      key: 'endDate',
    },
    {
      label: t('Starts with half day'),
      type: 'checkbox',
      key: 'startsWithHalfDay',
    },
    {
      label: t('Ends with half day'),
      type: 'checkbox',
      key: 'endsWithHalfDay',
    },
    {
      label: t('Is paid'),
      type: 'checkbox',
      key: 'isPaid',
    },
    {
      label: t('Is vacation'),
      type: 'checkbox',
      key: 'isVacation',
    },
  ];

  const validationSchema = Yup.object().shape({
    startDate: Yup.string().required(t('Start Date is required')),
    endDate: Yup.string().required(t('End Date is required')),
  });

  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: '',
  });

  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  function handleSubmit(values) {
    const isEdit = existingData?.id;
    DBRequest({
      config,
      path: isEdit ? `company-holidays/${existingData.id}` : 'company-holidays',
      method: isEdit ? API_PATCH(values) : API_POST(values),
      onResponse: (data) => {
        onSubmit(data.data);
        onCancel();
      },
      onFeedback: handleAlertOpen,
    });
  }

  function handleDelete() {
    DBRequest({
      config,
      path: `company-holidays/${existingData.id}`,
      method: API_DELETE(),
      onResponse: () => {
        onDelete(existingData.id);
        onCancel();
      },
      onFeedback: handleAlertOpen,
    });
  }

  return (
    <ExoForm
      noDifferences
      fields={fields}
      startDataCollection={existingData || { isPaid: 1, isVacation: 1 }}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      onDelete={existingData?.id ? handleDelete : undefined}
      validationSchema={validationSchema}
      header={t('Company Holiday')}
      className="grid grid-cols-2 gap-4 pt-2"
    >
      <Feedback setState={setAlertState} state={alertState} />
    </ExoForm>
  );
};

export default NewCompanyHoliday;
